import { PRIVATE_HTTP as http } from "../http-common";

const getSelfInspectionsAPI = async ( pageNumber: any = 1) => {
  if( typeof pageNumber === "string" ){
    return http().get(`/api/v4/self-inspections?q=${pageNumber}&page_number=${1}`);
  } else {
    return http().get(`/api/v4/self-inspections?page_number=${pageNumber}`);
  }
};

const validatePhotoAPI = async (id: number, formData: FormData) => {
  return http({formData: true}).post(`/api/v4/self-inspections/${id}/actions/validate-photo`, formData );
};

const sendSelfInspectionAPI = async (id: number) => {
  return http().get(`/api/v4/self-inspections/${id}/actions/finish`);
};

export {
  getSelfInspectionsAPI,
  validatePhotoAPI,
  sendSelfInspectionAPI
};
